import React, {Component} from 'react';
import PropTypes from 'prop-types';
import KiModal from 'components/KiModal';
import KiCheckbox from 'components/KiCheckbox';
import {deleteFundingVehicleSettings, updateFundingVehicleSetting} from '../actions';
import {connect} from 'react-redux';
import styles from './creditSupportsDeleteModal.theme.scss';
import _differenceBy from 'lodash/differenceBy';
import _countBy from 'lodash/countBy';
import {getNameId} from './creditSupportsForm';
import {fundingVehiclesApi} from 'api';
import DeletionDependencyErrors from './deletionDependencyErrors';

export class CreditSupportsDeleteModal extends Component {
	static propTypes = {
		active: PropTypes.bool,
		creditSupports: PropTypes.array,
		deleteFundingVehicleSettings: PropTypes.func.isRequired,
		updateFundingVehicleSetting: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
		title: PropTypes.string,
		nameKey: PropTypes.string,
	};

	static defaultProps = {
		active: false,
		creditSupports: [],
	};

	state = {
		selected: [],
		dependencies: [],
	};

	handleCheckboxClick = creditSupport => {
		this.setState(({selected}) => {
			const isPresent = selected.find(s => s._id === creditSupport._id);
			return {
				selected: isPresent ? selected.filter(s => s._id !== creditSupport._id) : [...selected, creditSupport],
			};
		});
	};

	handleDelete = () => {
		fundingVehiclesApi
			.getFundingVehicleSettingsDependencies('creditSupport', {
				datasetId: this.state.selected[0].datasetId,
				fundingVehicleId: this.state.selected[0].fundingVehicleId,
				entityIds: this.state.selected.map(e => e._id),
			})
			.then(results => {
				if (
					results.dependencies.filter(d => Array.isArray(d.dependencies) && d.dependencies.length > 0)
						.length > 0
				) {
					this.setState({
						dependencies: results.dependencies.filter(
							d => Array.isArray(d.dependencies) && d.dependencies.length > 0
						),
					});
				} else {
					const nonDeletedCreditSupports = _differenceBy(
						this.props.creditSupports,
						this.state.selected,
						'_id'
					);
					const supportTypeCount = _countBy(nonDeletedCreditSupports, 'supportType');

					for (const [key] of Object.entries(supportTypeCount)) {
						supportTypeCount[key] = 0;
					}

					nonDeletedCreditSupports.forEach(creditSupport => {
						supportTypeCount[creditSupport.supportType]++;
						creditSupport.supportNumber = supportTypeCount[creditSupport.supportType];
						creditSupport.nameId = getNameId(creditSupport.supportType, creditSupport.supportNumber);
						// TODO add ability to update many settings at once
						this.props.updateFundingVehicleSetting({_id: creditSupport._id, ...creditSupport}, true, true);
					});
					this.props.deleteFundingVehicleSettings(this.state.selected).then(() => this.props.onClose());
				}
			});
	};

	handleCheckAll = () => {
		this.setState({
			selected: this.state.selected.length === this.props.creditSupports.length ? [] : this.props.creditSupports,
		});
	};

	onCancel = () => {
		this.setState({dependencies: []});
		this.props.onClose();
	};

	render() {
		const {creditSupports} = this.props;
		return (
			<KiModal
				actions={[
					{
						label: 'Cancel',
						onClick: () => this.onCancel(),
					},
					{
						label: 'Delete',
						onClick: this.handleDelete,
						disabled: !this.state.selected.length,
					},
				]}
				active={!!this.props.creditSupports.length && this.props.active}
				header={this.props.title || 'Delete Accounts'}
				className="ki-modal fv-modal"
			>
				<section className={styles.body}>
					{creditSupports.map(creditSupport => (
						<div key={creditSupport._id} className={styles.checkboxWrapper}>
							<KiCheckbox
								className={styles.checkbox}
								label={creditSupport[this.props.nameKey || 'name']}
								checked={!!this.state.selected.find(selected => selected._id === creditSupport._id)}
								onChange={() => this.handleCheckboxClick(creditSupport)}
							/>
						</div>
					))}
				</section>
				{this.state.dependencies.length > 0 && (
					<DeletionDependencyErrors dependencies={this.state.dependencies} />
				)}
			</KiModal>
		);
	}
}

export default connect(null, {deleteFundingVehicleSettings, updateFundingVehicleSetting})(CreditSupportsDeleteModal);
